// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"38319e37","2700":"30a98f38","4945":"be9b7c2c","5688":"be9b7c2c","6320":"38319e37","7104":"b545e03f","7442":"be9b7c2c","8027":"38319e37","8730":"b545e03f","8887":"38319e37","9186":"9ca2e9fc","9831":"38319e37"}[chunkId] + ".chunk.css";
};